import type { DrillAndBlastFormType } from './types';

export const drillAndBlastValidator = (
  name: string,
  values: Partial<DrillAndBlastFormType>,
): string => {
  switch (name) {
    case 'title':
      return values.title?.trim()?.length ? '' : 'This field is required.';
    case 'spacingMeters':
    case 'burdenMeters':
      return values[name] === null || Number(values[name]) < 0
        ? 'This field is required.'
        : '';
    case 'baseElevationMeters':
      return values.baseElevationMeters === null
        ? 'This field is required.'
        : '';
    case 'drillPattern':
    case 'explosiveType':
      return values[name] ? '' : 'This field is required.';
    default:
      return '';
  }
};
